import React from "react";
import styles from "./styles.module.sass";

interface IProps {
    title: string;
}

const AdminPanelHeader = ({title}: IProps) => {
    return (
        <div className={styles.header}>
            <p className={styles.title}>{title}</p>
        </div>
    );
};

export default AdminPanelHeader;
